import { SEX } from './Sex';

export interface Profile {
  firstname: string;
  lastname: string;
  profession: string;
  titleAcademicPre: string;
  titleAcademicPost: string;
  sex: SEX;
}

export const defaultProfile: Profile = {
  firstname: '',
  lastname: '',
  profession: '',
  titleAcademicPre: '',
  titleAcademicPost: '',
  sex: SEX.FEMALE,
};
